import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CrSpinnerModule } from '../../shared/spinner/spinner.module';
import { SharedModule } from '../../shared';

import { EntitlementV3Component } from './components/entitlement-v3/entitlement-v3.component';

/**
 * Entitlement Module — Angular wrapper module.
 *
 * Declares the EntitlementV3Component, which embeds the Vite-built React
 * app at /entitlement-module/ inside an iframe. Mirrors the
 * VenueHoursModule pattern in ./venue-hours-angular/venue-hours.module.ts.
 *
 * Imported by `client.module.ts` so the wrapper is available everywhere
 * UI Router routes resolve.
 */
@NgModule({
    imports: [
        CommonModule,
        CrSpinnerModule,
        SharedModule,
    ],
    declarations: [
        EntitlementV3Component,
    ],
    exports: [
        EntitlementV3Component,
    ],
})
export class EntitlementModule {}
